import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-black text-body2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row text-body1 text-weight-bold text-black" }, " Användare ")
  ])
], -1)
const _hoisted_2 = { class: "row q-col-gutter-md q-mt-md" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = {
  key: 0,
  class: "col-6"
}
const _hoisted_5 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"max-width":"1000px","min-width":"800px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, {
        ref: "formRef",
        autocomplete: "off",
        greedy: "",
        onSubmit: _withModifiers(_ctx.onConfirm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    label: "Email",
                    modelValue: _ctx.model.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
                    rules: [_ctx.email]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                (_ctx.mode === 'ADD')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_q_input, {
                        min: "6",
                        max: "32",
                        outlined: "",
                        label: "Lösenord",
                        modelValue: _ctx.model.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
                        rules: [_ctx.minCharactersRule(6), _ctx.maxCharactersRule(32)]
                      }, null, 8, ["modelValue", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_q_select, {
                    outlined: "",
                    modelValue: _ctx.model.roles,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.roles) = $event)),
                    multiple: "",
                    "map-options": "",
                    "emit-value": "",
                    "option-label": "name",
                    "option-value": "uuid",
                    options: _ctx.roles,
                    clearable: "",
                    onClear: _cache[3] || (_cache[3] = () => (_ctx.model.roles = [])),
                    label: "Roller",
                    rules: [_ctx.requiredArray]
                  }, null, 8, ["modelValue", "options", "rules"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Stäng",
                onClick: _ctx.close,
                disable: _ctx.loading
              }, null, 8, ["onClick", "disable"]),
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Bekräfta",
                color: "primary",
                type: "submit",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}